// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.old-convo-container {
  height: 93% !important;
}

.custom-accordion {
  width: 100%;
}

.accordion-item {
  border: 1px solid #ddd;
  margin-bottom: 8px;
}

.accordion-header {
  padding: 10px;
  background-color: #f4f4f4;
  cursor: pointer;
}

.accordion-header:hover {
  background-color: #e0e0e0;
}

.accordion-header.active {
  background-color: #d4d4d4;
}

.accordion-content {
  padding: 10px;
}

.old-chat {
  display: flex;
  flex-direction: column;
}
.old-chat .user-info {
  display: flex;
  flex-direction: row;
}
.old-chat .user-info .user-info-details {
  text-align: left;
  width: 98%;
}
.old-chat .response-container {
  text-align: left;
  display: flex;
  overflow: auto;
  height: 100%;
  margin-top: 1em;
}
.old-chat .evr-response {
  margin-top: 0.25em;
  border-top: 2px double #004987;
}
.old-chat .evr-response-use-model {
  margin-top: 0.25em;
}
.old-chat .highlight-link {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.old-chat .btn-primary {
  background-color: #004987 !important;
}

.evr-chat {
  height: 45%;
}

.evr-chat-full {
  height: 89%;
}

.h-10 {
  height: 10%;
}

.h-auto {
  height: auto;
}

.rsis-container,
.rsis-image {
  display: flex !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
}

.old-chat-slider .splide__slide {
  display: flex;
  justify-content: center;
}
.old-chat-slider .splide {
  width: 90%;
}
.old-chat-slider .splide__pagination {
  bottom: -30px;
}
.old-chat-slider .splide__arrow--prev {
  left: 0em em;
}

.images-container {
  height: 20em;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid black;
  border-radius: 15px;
  margin-top: 1rem;
}
.images-container .image-details {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50%;
  margin: 2em 0;
}
.images-container .image-details .image-info {
  display: flex;
  flex-direction: column;
  width: 33%;
  padding: 0 1em;
  position: relative;
}
.images-container .image-details .image-info .cutom-image-details {
  width: 100%;
  height: 80%;
}
.images-container .image-details .image-info .source-details {
  height: 20%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.images-container .image-details .image-info .image_show {
  position: absolute;
  right: -5px;
  top: -25px;
}

.left-element {
  order: 1;
  /* Make it the first element */
}

.right-element {
  order: 2;
  /* Make it the second element */
  width: 10%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.images-container-child {
  width: 100%;
  height: 100%;
  padding-bottom: 0.5em;
  overflow: scroll;
  padding-right: 1em;
}

#custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  /* width of the scrollbar */
  display: none;
}

#custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
  /* make the track transparent */
}

#custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  /* use rgba to set thumb color with transparency */
  border-radius: 10px;
  /* roundness of the thumb */
  border: 2px solid transparent;
  /* make the thumb border transparent */
}

#custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
  /* change thumb color on hover */
}`, "",{"version":3,"sources":["webpack://./src/components/HHPCOldChat.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AAEE;EACE,WAAA;AACJ;;AAEE;EACE,sBAAA;EACA,kBAAA;AACJ;;AAEE;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAGE;EACE,aAAA;EACA,sBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;AAAN;AAEM;EACE,gBAAA;EACA,UAAA;AAAR;AAII;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAFN;AAKI;EACE,kBAAA;EACA,8BAAA;AAHN;AAKI;EACE,kBAAA;AAHN;AAMI;EACE,WAAA;EACA,0BAAA;EACA,eAAA;AAJN;AAOI;EACE,oCAAA;AALN;;AASE;EACE,WAAA;AANJ;;AASE;EACE,WAAA;AANJ;;AASE;EACE,WAAA;AANJ;;AASE;EACE,YAAA;AANJ;;AASE;;EAEE,wBAAA;EACA,6BAAA;EACA,qBAAA;EACA,oBAAA;AANJ;;AAUI;EACE,aAAA;EACA,uBAAA;AAPN;AAUI;EACE,UAAA;AARN;AAWI;EACE,aAAA;AATN;AAYI;EACE,YAAA;AAVN;;AAcE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAXJ;AAcI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;AAZN;AAcM;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AAZR;AAcQ;EACE,WAAA;EACA,WAAA;AAZV;AAeQ;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAbV;AAgBQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAdV;;AAsBE;EACE,QAAA;EACA,8BAAA;AAnBJ;;AAsBE;EACE,QAAA;EACA,+BAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAnBJ;;AA0BE;EAEE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAxBJ;;AA2BE;EACE,UAAA;EACA,2BAAA;EACA,aAAA;AAxBJ;;AA2BE;EACE,uBAAA;EACA,+BAAA;AAxBJ;;AA2BE;EACE,oCAAA;EACA,kDAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;EACA,sCAAA;AAxBJ;;AA2BE;EACE,oCAAA;EACA,gCAAA;AAxBJ","sourcesContent":[".old-convo-container {\n    height: 93% !important;\n  }\n  \n  .custom-accordion {\n    width: 100%;\n  }\n  \n  .accordion-item {\n    border: 1px solid #ddd;\n    margin-bottom: 8px;\n  }\n  \n  .accordion-header {\n    padding: 10px;\n    background-color: #f4f4f4;\n    cursor: pointer;\n  }\n  \n  .accordion-header:hover {\n    background-color: #e0e0e0;\n  }\n  \n  .accordion-header.active {\n    background-color: #d4d4d4;\n  }\n  \n  .accordion-content {\n    padding: 10px;\n  }\n  \n  \n  .old-chat {\n    display: flex;\n    flex-direction: column;\n  \n    .user-info {\n      display: flex;\n      flex-direction: row;\n  \n      .user-info-details {\n        text-align: left;\n        width: 98%;\n      }\n    }\n  \n    .response-container {\n      text-align: left;\n      display: flex;\n      overflow: auto;\n      height: 100%;\n      margin-top: 1em;\n    }\n  \n    .evr-response {\n      margin-top: .25em;\n      border-top: 2px double #004987;\n    }\n    .evr-response-use-model{\n      margin-top: .25em;\n    }\n  \n    .highlight-link {\n      color: blue;\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  \n    .btn-primary {\n      background-color: #004987 !important;\n    }\n  }\n  \n  .evr-chat {\n    height: 45%;\n  }\n  \n  .evr-chat-full {\n    height: 89%;\n  }\n  \n  .h-10 {\n    height: 10%;\n  }\n\n  .h-auto {\n    height: auto;\n  }\n\n  .rsis-container,\n  .rsis-image {\n    display: flex !important;\n    position: relative !important;\n    left: auto !important;\n    top: auto !important;\n  }\n  \n  .old-chat-slider {\n    .splide__slide {\n      display: flex;\n      justify-content: center;\n    }\n  \n    .splide {\n      width: 90%;\n    }\n  \n    .splide__pagination {\n      bottom: -30px;\n    }\n  \n    .splide__arrow--prev {\n      left: 0em em;\n    }\n  }\n  \n  .images-container {\n    height: 20em;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    border: 1px solid black;\n    border-radius: 15px;\n    margin-top: 1rem;\n    // overflow-y: auto;\n  \n    .image-details {\n      display: flex;\n      flex-direction: row;\n      width: 100%;\n      height: 50%;\n      margin: 2em 0;\n  \n      .image-info {\n        display: flex;\n        flex-direction: column;\n        width: 33%;\n        padding: 0 1em;\n        position: relative;\n  \n        .cutom-image-details {\n          width: 100%;\n          height: 80%;\n        }\n  \n        .source-details {\n          height: 20%;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n  \n        .image_show {\n          position: absolute;\n          right: -5px;\n          top: -25px;\n        }\n      }\n    }\n  \n  \n  }\n  \n  .left-element {\n    order: 1;\n    /* Make it the first element */\n  }\n  \n  .right-element {\n    order: 2;\n    /* Make it the second element */\n    width: 10%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n  \n  // .image-container { \n  //   height: 300px; \n  //   overflow-y: scroll; \n  // } \n  .images-container-child {\n  \n    width: 100%;\n    height: 100%;\n    padding-bottom: .5em;\n    overflow: scroll;\n    padding-right: 1em;\n  }\n  \n  #custom-scrollbar::-webkit-scrollbar {\n    width: 8px;\n    /* width of the scrollbar */\n    display: none;\n  }\n  \n  #custom-scrollbar::-webkit-scrollbar-track {\n    background: transparent;\n    /* make the track transparent */\n  }\n  \n  #custom-scrollbar::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.3);\n    /* use rgba to set thumb color with transparency */\n    border-radius: 10px;\n    /* roundness of the thumb */\n    border: 2px solid transparent;\n    /* make the thumb border transparent */\n  }\n  \n  #custom-scrollbar::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(0, 0, 0, 0.5);\n    /* change thumb color on hover */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
